<template>
    <tr>
      <!-- using the first td to sort by, due to tablesorter limitation we hide this from showing -->
      <td class="hide-td">{{machine.networkNode}}</td>
      <td>{{machineType}} {{machine.machineDisplayName}}</td>
      <td>{{machine.machineSize}}</td>
      <td><status-pill :status="machine.statusId" :themeConfig="themeConfig"></status-pill></td>
      <td v-if="isActive">
       <time-remaining :remainingSeconds="machine.remainingSeconds"></time-remaining>

        <div v-if="isActive">
          <div v-if="!hasSubscribed">
            <a @click="show">
              Create Alert
            </a>
          </div>

          <div v-else>
            <span>Subscribed</span>
          </div>
        </div>

      </td>
      <td v-else></td>
    </tr>
</template>

<script>

import StatusPill from "./machine/StatusPill";
import TimeRemaining from "./machine/TimeRemaining";

export default {
  name: "Subcribe",
  props: {
    machine: Object,
    template: Object,
    canSms: Boolean,
    themeConfig: Object,
  },
  data() {
    return {
      hasSubscribed: false
    };
  },
  components: {
    "status-pill": StatusPill,
    "time-remaining": TimeRemaining
  },
  computed: {

    isActive() {
      let mStatus = this.machine.statusId;

      if (
        mStatus == "in_use" ||
        mStatus == "lucky_cycle" ||
        mStatus == "ready_to_start"
      ) {
        return true;
      }
    },

    machineType() {
      return this.machine.isWasher ? "Washer" : "Dryer";
    }
  },
  methods: {
    show() {
      this.$parent.showAlertModal(this.machine, this.template, this);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MachineRow.vue